// extracted by mini-css-extract-plugin
export default {"header":"HeaderMenu_header__ZbuWw","inner":"HeaderMenu_inner__bTikg","link":"HeaderMenu_link__uZnNX","linkLabel":"HeaderMenu_linkLabel__eq8T3"};